const MainColumn = () => {
  return <div>MAIN</div>
}

export default MainColumn
